import React from "react";
import t from "./translate";
import Col from "react-bootstrap/Col";
import Row from "react-bootstrap/Row";
import Container from "react-bootstrap/Container";

export default function Footer() {
  return (
    <div className={'footer'}>
      <Container>
        <div className="d-inline-flex flex-wrap">
          <div className="w-sm-100 w-xs-100">
            <a 
              className="" 
              target="_blank"
              href="https://www.wings.hs-wismar.de/">
              {t("copyRightWings")}
            </a>
          </div>
          <span className="d-none d-md-inline-block">&nbsp; | &nbsp;</span>
          <div className="w-sm-100 w-xs-100">
            <a
              className=""
              target="_blank"
              href="https://www.wings.hs-wismar.de/de/wings/anbieterkennzeichnung"
            >
              {t("legalInformationLinkLabel")}
            </a>
          </div>
          <span className="d-none d-md-inline-block">&nbsp; | &nbsp;</span>
          <div className="w-sm-100 w-xs-100">
            <a
              className=""
              target="_blank"
              href="https://www.wings.hs-wismar.de/de/wings/anbieterkennzeichnung/datenschutzerklaerung"
            >
              {t("dataProtectionLinkLabel")}
            </a>
          </div>
        </div>
      </Container>
    </div>
  );
}
